import React from 'react';
import { Link } from 'react-router-dom';
// Importação dos componentes de Header e Footer
import HeaderTwo from "../header/HeaderTwo";
import FooterTwo from "../footer/FooterTwo";

function GbMainServices() {
  return (
    <>
      {/* Cabeçalho superior */}
      <HeaderTwo />

      <div className="rts-service-area rts-section-gapTop pb--200 service-two-bg bg_image">
        <div className="container">
          <div className="row g-5 service padding-controler">

            {/* CRÉDITO EMPRESARIAL */}
            <div className="col-xl-4 col-md-6 col-sm-12 col-12 pb--140 pb_md--100">
              <div className="service-two-inner">
                <Link to="/servicos/credito-empresarial" className="thumbnail">
                  {/* Ajustado: /assets/... */}
                  <img src="/assets/images/servicos/1/1.png" alt="Crédito Empresarial" />
                </Link>
                <div className="body-content">
                  <div className="hidden-area">
                    <h5 className="title">Crédito Empresarial</h5>
                    <p className="dsic">
                      Estruturação de operações financeiras sob medida para empresas que buscam expansão e liquidez.
                    </p>
                    <Link className="rts-read-more-two color-primary" to="/servicos/credito-empresarial">
                      Saiba mais <i className="far fa-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* AGRO */}
            <div className="col-xl-4 col-md-6 col-sm-12 col-12 pb--140 pb_md--100">
              <div className="service-two-inner">
                <Link to="/servicos/agro" className="thumbnail two">
                  {/* Ajustado: /assets/... */}
                  <img src="/assets/images/servicos/1/2.png" alt="Agro" />
                </Link>
                <div className="body-content">
                  <div className="hidden-area">
                    <h5 className="title">Agro</h5>
                    <p className="dsic">
                      Soluções financeiras e inteligência estratégica para o agronegócio, do campo ao mercado.
                    </p>
                    <Link className="rts-read-more-two color-primary" to="/servicos/agro">
                      Saiba mais <i className="far fa-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* SEGUROS */}
            <div className="col-xl-4 col-md-6 col-sm-12 col-12 pb--140 pb_md--100">
              <div className="service-two-inner">
                <Link to="/servicos/seguros" className="thumbnail three">
                  {/* Ajustado: /assets/... */}
                  <img src="/assets/images/servicos/1/5.png" alt="Seguros" />
                </Link>
                <div className="body-content">
                  <div className="hidden-area">
                    <h5 className="title">Seguros</h5>
                    <p className="dsic">
                      Proteção patrimonial completa para ativos empresariais e rurais, garantindo continuidade ao negócio.
                    </p>
                    <Link className="rts-read-more-two color-primary" to="/servicos/seguros">
                      Saiba mais <i className="far fa-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* CRÉDITO DE CARBONO */}
            <div className="col-xl-4 col-md-6 col-sm-12 col-12 pb--140 pb_md--60">
              <div className="service-two-inner">
                <Link to="/servicos/credito-carbono" className="thumbnail">
                  {/* Ajustado: /assets/... */}
                  <img src="/assets/images/servicos/1/4.png" alt="Crédito de Carbono" />
                </Link>
                <div className="body-content">
                  <div className="hidden-area">
                    <h5 className="title">Crédito de Carbono</h5>
                    <p className="dsic">
                      Estruturação de ativos ambientais e monetização sustentável para transformar preservação em receita.
                    </p>
                    <Link className="rts-read-more-two color-primary" to="/servicos/credito-carbono">
                      Saiba mais <i className="far fa-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* INTELIGÊNCIA DE MERCADO */}
            <div className="col-xl-4 col-md-6 col-sm-12 col-12 pb--140 pb_md--60 pb_sm--60">
              <div className="service-two-inner">
                <Link to="/servicos/inteligencia-mercado" className="thumbnail two">
                  {/* Ajustado: /assets/... */}
                  <img src="/assets/images/servicos/1/3.png" alt="Inteligência de Mercado" />
                </Link>
                <div className="body-content">
                  <div className="hidden-area">
                    <h5 className="title">Inteligência de Mercado</h5>
                    <p className="dsic">
                      Análise estratégica e estruturação financeira avançada para embasar decisões de alto impacto.
                    </p>
                    <Link className="rts-read-more-two color-primary" to="/servicos/inteligencia-mercado">
                      Saiba mais <i className="far fa-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Rodapé inferior */}
      <FooterTwo />
    </>
  );
}

export default GbMainServices;